import React from 'react';
export function PrivacyPolicyEnglish() {
  return <div className="prose prose-invert max-w-none space-y-8 text-gray-400" data-id="element-223">
      <section data-id="element-224">
        <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-225">
          1. Privacy at a Glance
        </h2>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-226">
          General Information
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-227">
          The following information provides a simple overview of what happens
          to your personal data when you visit this website. Personal data is
          any data that can be used to identify you personally. Detailed
          information on data protection can be found in the privacy policy
          below.
        </p>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-228">
          Data Collection on This Website
        </h3>
        <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-229">
          Who is responsible for data collection on this website?
        </h4>
        <p className="leading-relaxed mb-4" data-id="element-230">
          Data processing on this website is carried out by the website
          operator. You can find the operator&apos;s contact details in the
          “Responsible Entity / Data Controller” section of this Privacy Policy.
        </p>

        <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-231">
          How do we collect your data?
        </h4>
        <p className="leading-relaxed mb-4" data-id="element-232">
          Some data is collected when you provide it to us, for example when you
          enter information into a contact form. Other data is collected
          automatically, or with your consent, by our IT systems when you visit
          this website. This is primarily technical data, such as your browser,
          operating system, or the time of page access.
        </p>

        <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-233">
          What do we use your data for?
        </h4>
        <p className="leading-relaxed mb-4" data-id="element-234">
          Some data is collected to ensure that the website is provided without
          errors. Other data may be used to analyse your use of the website.
        </p>

        <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-235">
          What rights do you have regarding your data?
        </h4>
        <p className="leading-relaxed mb-4" data-id="element-236">
          You have the right to receive information about the origin, recipient,
          and purpose of your stored personal data free of charge at any time.
          You also have the right to request the correction or deletion of this
          data. If you have given consent to data processing, you may withdraw
          that consent at any time with future effect. You also have the right,
          in certain circumstances, to request that processing of your personal
          data be restricted. In addition, you have the right to lodge a
          complaint with the relevant supervisory authority.
        </p>

        <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-237">
          Analytics and third-party tools
        </h4>
        <p className="leading-relaxed mb-4" data-id="element-238">
          When you visit this website, your browsing behaviour may be evaluated
          statistically. This is mainly done using analytics programs. Detailed
          information about these programs can be found in this Privacy Policy.
        </p>
      </section>

      <section data-id="element-239">
        <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-240">2. Hosting</h2>
        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-241">Webflow</h3>
        <p className="leading-relaxed mb-4" data-id="element-242">
          We host our website with Webflow. The provider is Webflow, Inc., 398
          11th Street, 2nd Floor, San Francisco, CA 94103, USA (hereinafter
          “Webflow”). When you visit our website, Webflow collects various log
          files, including your IP address.
        </p>
        <p className="leading-relaxed mb-4" data-id="element-243">
          Webflow is a tool for creating and hosting websites. Webflow stores
          cookies or other recognition technologies that are necessary to
          display the site, provide certain website functions, and ensure
          security.
        </p>
        <p className="leading-relaxed mb-4" data-id="element-244">
          Further details can be found in Webflow&apos;s Privacy Policy:{' '}
          <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-245">
            https://webflow.com/legal/eu-privacy-policy
          </a>
          .
        </p>
        <p className="leading-relaxed mb-4" data-id="element-246">
          The use of Webflow is based on our legitimate interest in providing
          our website as reliably as possible. Where consent has been requested,
          processing takes place exclusively on the basis of that consent. You
          may withdraw your consent at any time with future effect.
        </p>
        <p className="leading-relaxed mb-4" data-id="element-247">
          Transfers of data to the United States are based on the European
          Commission&apos;s standard contractual clauses. Details are available
          at the Webflow Privacy Policy linked above.
        </p>
      </section>

      <section data-id="element-248">
        <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-249">
          3. General Information and Mandatory Disclosures
        </h2>
        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-250">
          Data Protection
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-251">
          The operators of these pages take the protection of your personal data
          very seriously. We treat your personal data confidentially and in
          accordance with applicable data protection law and this Privacy
          Policy.
        </p>
        <p className="leading-relaxed mb-4" data-id="element-252">
          When you use this website, various personal data may be collected.
          This Privacy Policy explains which data we collect, what we use it
          for, and how and for what purpose this happens.
        </p>
        <p className="leading-relaxed mb-4" data-id="element-253">
          Please note that data transmission over the internet, for example when
          communicating by email, may have security gaps. Complete protection of
          data against access by third parties is not possible.
        </p>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-254">
          Responsible Entity / Data Controller
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-255">
          The responsible entity for data processing on this website is:
        </p>
        <p className="leading-relaxed mb-4" data-id="element-256">
          CRM Kraft LLC
          <br data-id="element-257" />
          Represented by: Justus Kraft
          <br data-id="element-258" />
          7901 4th St. N, Ste. 300
          <br data-id="element-259" />
          St. Petersburg, FL 33702
          <br data-id="element-260" />
          United States of America
          <br data-id="element-261" />
          Phone: +49 157 35999071
          <br data-id="element-262" />
          Email: justus@crm-kraft.de
        </p>
        <p className="leading-relaxed mb-4" data-id="element-263">
          The responsible entity is the natural or legal person who, alone or
          jointly with others, determines the purposes and means of processing
          personal data, such as names and email addresses.
        </p>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-264">
          Retention Period
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-265">
          Unless a more specific retention period is stated in this Privacy
          Policy, we retain your personal data until the purpose for processing
          no longer applies. If you submit a legitimate request for erasure or
          withdraw consent, your data will be deleted unless we have other
          legally permissible reasons for retaining it, such as statutory
          retention obligations.
        </p>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-266">
          SSL/TLS Encryption
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-267">
          This website uses SSL or TLS encryption for security reasons and to
          protect the transmission of confidential content, such as enquiries
          sent to us. You can recognise an encrypted connection when your
          browser&apos;s address line changes from “http://” to “https://” and a
          lock symbol appears in the address bar.
        </p>
        <p className="leading-relaxed mb-4" data-id="element-268">
          When SSL or TLS encryption is enabled, the data you transmit to us
          cannot be read by third parties.
        </p>
      </section>

      <section data-id="element-269">
        <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-270">
          4. Data Collection on This Website
        </h2>
        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-271">Cookies</h3>
        <p className="leading-relaxed mb-4" data-id="element-272">
          Our websites use cookies. Cookies are small text files that do not
          harm your device. They are stored either temporarily for the duration
          of a session or permanently. Session cookies are automatically deleted
          when you end your visit. Permanent cookies remain on your device until
          you delete them or your browser deletes them automatically.
        </p>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-273">
          Contact Form
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-274">
          If you send us enquiries via the contact form, the information you
          provide, including your contact details, will be stored by us to
          process your enquiry and in case of follow-up questions. We do not
          share this data without your consent.
        </p>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-275">
          Enquiries by Email, Telephone, or Fax
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-276">
          If you contact us by email, telephone, or fax, your enquiry, including
          all associated personal data, such as your name and enquiry, will be
          stored and processed for the purpose of handling your request. We do
          not share this data without your consent.
        </p>
      </section>

      <section data-id="element-277">
        <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-278">
          5. Plugins and Tools
        </h2>
        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-279">YouTube</h3>
        <p className="leading-relaxed mb-4" data-id="element-280">
          This website embeds videos from YouTube. The operator of the service
          is Google Ireland Limited, Gordon House, Barrow Street, Dublin 4,
          Ireland.
        </p>
        <p className="leading-relaxed mb-4" data-id="element-281">
          Further information on the handling of user data can be found in
          YouTube&apos;s Privacy Policy:{' '}
          <a href="https://policies.google.com/privacy?hl=en" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-282">
            https://policies.google.com/privacy?hl=en
          </a>
          .
        </p>

        <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-283">
          Google Web Fonts
        </h3>
        <p className="leading-relaxed mb-4" data-id="element-284">
          This website uses web fonts provided by Google to display fonts
          consistently. When you open a page, your browser loads the required
          web fonts into its cache to display text and fonts correctly.
        </p>
      </section>
    </div>;
}